import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';
import styled from 'styled-components';

import isEmpty from 'lodash/isEmpty';
import Field from '../fields/Field';
import Textareafield from '../fields/Textareafield';
import Btn from '../buttons/Btn';
import { NOTES_COLOR } from '../../theme';
import { InsurancePrefilledForm } from './InsurancePrefilledForm';

const FieldWrap = styled.div`
  max-width: 508px;
  margin: 24px 0;

  input,
  textarea {
    font-size: 16px;
  }
`;

const SmallFieldWrap = styled(FieldWrap)`
  max-width: 224px;
`;

const BtnWrap = styled(FieldWrap)`
  max-width: 254px;
`;

const Footnote = styled.div`
  font-size: 14px;
  line-height: 1.17;
  letter-spacing: -0.1px;
  color: ${NOTES_COLOR};
`;

const InsuranceFormComponent = ({
  initialValues, onSubmit, validationSchema, userInfo,
}) => (
  <Formik initialValues={initialValues} onSubmit={onSubmit} validationSchema={validationSchema}>
    {({
      values, handleBlur, handleChange, errors, touched, isSubmitting,
    }) => (
      <Form>
        {isEmpty(userInfo) ? (
          <>
            <FieldWrap>
              <Field
                label="Prénom"
                placeholder="Louis"
                type="text"
                name="firstname"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.firstname}
                valid={touched.firstname && !errors.firstname}
                errorMessage={errors.firstname && touched.firstname ? errors.firstname : null}
              />
            </FieldWrap>
            <FieldWrap>
              <Field
                label="Nom"
                placeholder="Dupont"
                type="text"
                name="lastname"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.lastname}
                valid={touched.lastname && !errors.lastname}
                errorMessage={errors.lastname && touched.lastname ? errors.lastname : null}
              />
            </FieldWrap>
            <SmallFieldWrap>
              <Field
                label="Téléphone"
                placeholder="0601020304"
                type="text"
                name="phone"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.phone}
                valid={touched.phone && !errors.phone}
                errorMessage={errors.phone && touched.phone ? errors.phone : null}
              />
            </SmallFieldWrap>
            <FieldWrap>
              <Field
                label="Email"
                placeholder="louis.dupont@vroomvroom.fr"
                type="text"
                name="email"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.email}
                valid={touched.email && !errors.email}
                errorMessage={errors.email && touched.email ? errors.email : null}
              />
            </FieldWrap>
          </>
        ) : (
          <InsurancePrefilledForm userInfo={userInfo} />
        )}
        <FieldWrap>
          <Textareafield
            label="Message"
            name="message"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.message}
            valid={touched.message && !errors.message}
            errorMessage={errors.message && touched.message ? errors.message : null}
          />
        </FieldWrap>
        <BtnWrap>
          <Btn
            type="submit"
            text="Envoyer"
            isLoading={isSubmitting}
            disabled={isSubmitting}
            block
            name="submitReview"
          />
        </BtnWrap>
        <Footnote>
          Les données de ce formulaire font l’objet de traitements dont le responsable est Vroom
          France - 13 rue Olier 75015 Paris. Elles sont transmises à notre partenaire Filhet-Allard.
          Elles sont conservées pour une durée maximale de trois (3) ans. Vous disposez d’un droit
          d’accès, de rectification, de limitation, de portabilité, d’opposition, de suppression et
          vous pouvez définir des directives post mortem relatives à vos données. Vous pouvez
          exercer vos droits en envoyant un email à
          {' '}
          <a href="mailto:contact@vroomvroom.fr">contact@vroomvroom.fr</a>
          {' '}
          ou en contactant le
          Délégué à la protection des données de Vroom France. Pour en savoir plus, vous pouvez
          consulter notre
          {' '}
          <a href="/a-propos/donnees-personnelles" target="_blank" rel="noopener noreferrer">
            politique de protection des données.
          </a>
        </Footnote>
      </Form>
    )}
  </Formik>
);

InsuranceFormComponent.propTypes = {
  initialValues: PropTypes.shape({
    firstname: PropTypes.string,
    lastname: PropTypes.string,
    phone: PropTypes.string,
    email: PropTypes.string,
    message: PropTypes.string,
  }).isRequired,
  onSubmit: PropTypes.func.isRequired,
  validationSchema: PropTypes.object,
  userInfo: PropTypes.shape({
    firstname: PropTypes.string,
    lastname: PropTypes.string,
    phone: PropTypes.string,
    email: PropTypes.string,
  }),
};

InsuranceFormComponent.defaultProps = {
  validationSchema: null,
  userInfo: null,
};

export { InsuranceFormComponent };
